/**
 * Business rules of the phyto specifications (Masterdata V2 Specifications screen, AO-11836).
 */
export const SpecificationRules = {
  /** Dosage unit offered first when adding a product to a specification. */
  DEFAULT_RATE_UNIT: 'L/HA',

  /**
   * RG1: the cumulative dose a specification allows for a product is its dosage times its number
   * of passages. It is computed, never entered. Rounded to absorb floating-point noise
   * (0.1 × 3 gives 0.3, not 0.30000000000000004).
   */
  cumulative(dosage: number, passageNumber: number): number {
    return Math.round(dosage * passageNumber * 1e6) / 1e6
  },

  /** RG4: locked reference specifications can be neither edited nor deleted. */
  canEditOrDelete(specification: { isEditable: boolean }): boolean {
    return specification.isEditable
  },

  /**
   * A product is linked to a specification through its registration in the specification's country, so the
   * country can only change while the specification holds no product.
   */
  canChangeCountry(productsCount: number): boolean {
    return productsCount === 0
  },

  /**
   * RG2 and RG3: a product can be added to a specification only when it is active and not in the
   * specification yet. An inactive product already in a specification stays there.
   */
  canAddProduct(product: { id: number; isActive: boolean }, productIdsInSpecification: number[]): boolean {
    return product.isActive && !productIdsInSpecification.includes(product.id)
  },
} as const
